import { Card, CardBody, Typography } from "@material-tailwind/react";
import EmptyState from "../../components/common/EmptyState";

function EmptyBooking() {
  return (
    <Card   placeholder={undefined} className="rounded-3xl w-full">
      <CardBody   placeholder={undefined} className="justify-center items-center">
        <div className="justify-center flex h-20 ">
          <EmptyState />
        </div>
        <Typography   placeholder={undefined} className="text-center">
          No Bookings have been made yet
        </Typography>
      </CardBody>
    </Card>
  );
}

export default EmptyBooking;
